import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { PPI } from '@ikea-food-ux/ppsi';
import DataContext from '../components/DataContext/DataContext';
import RedirectToMenu from '../components/util/Redirect';
import TabletBottomBar from '../components/Layout/TabletBottomBar';

const PPIView = () => {
  const { id } = useParams();
  const {
    ppis,
    labels,
    timeUnits,
    temperatureUnits,
    firstStorage,
    productionOptions,
    language,
    shelfLifeTimeUnits
  } = useContext(DataContext);
  let ppi = ppis.find(ppi => ppi.id === id);
  if (!ppi) {
    console.warn(`Ops! No PPI available with given id :(   (${id})`);
    return <RedirectToMenu />;
  }
  const ingredient = { itemCode: ppi.itemCode };
  ppi={ ...ppi, isNew: ppi.ppiTag === 'new', isUpdated: ppi.ppiTag==='updated' }
  return (
    <>
    <PPI
      ppi={ppi}
      ingredient={ingredient}
      labels={labels}
      timeUnits={timeUnits}
      temperatureUnits={temperatureUnits}
      stockHierarchy={firstStorage}
      productionOptions={productionOptions}
      language={language}
      showScrollToTop={false}
      shelfLifeTimeUnits={shelfLifeTimeUnits}
    />
    <TabletBottomBar/>
    </>
  );
};

export default PPIView;
